module.exports = __webpack_public_path__ + "src/assets/img/cmd-cl-close.ef4d62a3.svg";